import { useContainer } from '../../useContainer';
import { AbsenceReportApi } from '../../../api';
import { AbsenceReportApiResponse } from '../../../api/AbsenceReportApi';
import useAbsenceReportPolling from './useAbsenceReportPolling';

type MonthlyTrendData = AbsenceReportApiResponse.GetMonthlyTrend['body'];

const useHttpGetMonthlyTrend = () => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);

    return useAbsenceReportPolling<MonthlyTrendData>(handlers => absenceReportApi.getMonthlyTrend(handlers), { dataAvailable: false });
};

export default useHttpGetMonthlyTrend;
